import type { SponsoredDisplayCapabilities } from "@adpilot/shared";

export type CampaignType = "sp" | "sb" | "sd";
export type SponsoredBrandsEligibility = "idle" | "checking" | "available" | "unavailable";
export type SponsoredDisplayAvailability =
  | "idle"
  | "checking"
  | "available"
  | "unsupported"
  | "unavailable";

interface AvailabilityQuery<T> {
  isLoading: boolean;
  data: T | undefined;
}

export function getSponsoredBrandsEligibility(
  selectedShopId: string | null,
  eligibility: AvailabilityQuery<boolean>,
): SponsoredBrandsEligibility {
  if (!selectedShopId) return "idle";
  if (eligibility.isLoading) return "checking";
  return eligibility.data === true ? "available" : "unavailable";
}

export function getSponsoredDisplayAvailability(
  selectedShopId: string | null,
  capabilities: AvailabilityQuery<SponsoredDisplayCapabilities>,
): SponsoredDisplayAvailability {
  if (!selectedShopId) return "idle";
  if (capabilities.isLoading) return "checking";
  const campaignCreation = capabilities.data?.campaignCreation;
  if (campaignCreation?.state === "supported") return "available";
  // A product-scope `implementation_pending` gap is not retryable, so it reads as unsupported.
  if (
    campaignCreation?.state === "unsupported" ||
    campaignCreation?.reason === "implementation_pending"
  )
    return "unsupported";
  return "unavailable";
}
